<template>
  <div class="absolute inset-0 z-10 flex items-center justify-center bg-white/80">
    <div class="flex flex-col items-center text-center px-24 max-w-[400px]">
      <MessagesIllustration class="mx-auto" />
      <p class="text-h4 mt-24">Pick up the conversation with your sitters</p>
      <p class="my-24 text-body">Upgrade to premium to access your previous messages and continue the conversation</p>
      <Button value="View pricing" variant="primary" size="medium" href="/upgrade/pricing" @click="trackClick" />
    </div>
  </div>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import MessagesIllustration from '@/graphics/illustrations/MessagesIllustration.vue';
import { sendSegmentEvent } from '@/lib/segment';

export default {
  name: 'UpgradePrompt',
  components: { MessagesIllustration, Button },
  methods: {
    trackClick() {
      sendSegmentEvent('Messaging See Pricing', {});
    },
  },
};
</script>
